import type { FC } from 'react';

import cn from 'classnames';

import * as styles from './Description.module.scss';

interface DescriptionProps {
  description?: string | null;
  className?: string;
}

const Description: FC<DescriptionProps> = ({ description, className }) => {
  return Boolean(description) ? (
    <div className={cn(styles.description, className)}>{description}</div>
  ) : null;
};

export { Description };
